import { useState } from "react";
import { faqItems } from "@/mocks/siteData";

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="w-full max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-500">关于爱情岛论坛，您可能想了解的问题</p>
        </div>

        <div className="flex flex-col gap-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg border border-background-200/60 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer"
                onClick={() => toggleFAQ(index)}
                aria-expanded={openIndex === index}
              >
                <h4 className="text-sm md:text-base font-semibold text-foreground-950 pr-4">
                  {item.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openIndex === index ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-500"
                }`}>
                  <i className={`text-sm transition-transform duration-300 ${openIndex === index ? "ri-subtract-line" : "ri-add-line"}`}></i>
                </div>
              </button>

              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? "max-h-96 pb-4 md:pb-5 px-4 md:px-5" : "max-h-0"
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {item.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}